import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { AppointmentState } from "../../../appointment-details/appointment-details.types.js";
import CancelIcon from "../../assets/icons/Cancel.js";
import ControlledCheckIcon from "../../assets/icons/ControlledCheckIcon.js";
import ControlledDoubleCheckIcon from "../../assets/icons/ControlledDoubleCheckIcon.js";
import InClinicIcon from "../../assets/icons/InClinic.js";
import InTreatmentIcon from "../../assets/icons/InTreatment.js";
import OpenIcon from "../../assets/icons/Open.js";
import TreatmentCompleteIcon from "../../assets/icons/TreatmentComplete.js";
import TreatmentRoomIcon from "../../assets/icons/TreatmentRoom.js";
import WaitingIcon from "../../assets/icons/Waiting.js";
import { StyledChip } from "./appointment-status.styles.js";
import "@mui/material";
import "@mui/material/styles";
const StatusIconMap = {
  [AppointmentState.OPEN]: /* @__PURE__ */ jsx(OpenIcon, {}),
  [AppointmentState.IN_CLINIC]: /* @__PURE__ */ jsx(InClinicIcon, {}),
  [AppointmentState.WAITING]: /* @__PURE__ */ jsx(WaitingIcon, {}),
  [AppointmentState.CANCELED]: /* @__PURE__ */ jsx(CancelIcon, {}),
  [AppointmentState.IN_TREATMENT]: /* @__PURE__ */ jsx(InTreatmentIcon, {}),
  [AppointmentState.IN_TREATMENT_ROOM]: /* @__PURE__ */ jsx(TreatmentRoomIcon, {}),
  [AppointmentState.TREATED]: /* @__PURE__ */ jsx(TreatmentCompleteIcon, {})
};
const AppointmentStatus = ({ isInClinic, cancellation, state, stateControlled, stateControlledAccounting }) => {
  const label = useMemo(() => {
    if (isInClinic) {
      return StatusIconMap[AppointmentState.IN_CLINIC];
    }
    if (stateControlled && stateControlledAccounting) {
      return /* @__PURE__ */ jsx(ControlledDoubleCheckIcon, {});
    }
    if (stateControlled || stateControlledAccounting) {
      return /* @__PURE__ */ jsx(ControlledCheckIcon, {});
    }
    const currentState = cancellation ? AppointmentState.CANCELED : state;
    return StatusIconMap[currentState];
  }, [isInClinic, cancellation, state, stateControlled, stateControlledAccounting]);
  return /* @__PURE__ */ jsx(StyledChip, { label });
};
export {
  AppointmentStatus as default
};
